/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ApproverDisplay from '../ApproverDropdown/container';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './recursiveAccordion.module.scss';
import deleteIcon from '../../../../../Assets/images/svg/dar_delete.svg';
import editIcon from '../../../../../Assets/images/svg/dar_edit.svg';

const RecursiveAccordion = ({
  node,
  approverOptions,
  updateDetails,
  level = 0,
  handleEdit,
  handleDelete,
  hasAccess,
}) => {
  const [details, setDetails] = useState(
    node?.details || {
      firstApprover: '',
      secondApprover: '',
      thirdApprover: '',
    }
  );

  const [expanded, setExpanded] = useState(false);

  const handleApproverChange = (approverNumber, value) => {
    const newDetails = { ...details, [approverNumber]: value };
    setDetails(newDetails);
    updateDetails(node.id, newDetails);
  };

  const handleChange = () => setExpanded((prev) => !prev);

  const isTopLevel = level === 0;

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={handleChange}
        className={styles.accordion}
        sx={{
          boxShadow: '0px 0px 4px 0px #00000026',
          border: 'none',
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary className={styles['accordion-summary']}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', gap: '10px' }}>
              <ExpandMoreIcon
                className="accordion-icon"
                sx={{ transition: 'transform 0.3s ease', marginRight: '8px' }}
              />
              <div className={styles.parameter}>{`${node.parameter} :`}</div>
              <div
                className={styles['parameter-value']}
              >{`${node.parameterLabel}`}</div>
            </div>

            {isTopLevel && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit();
                  }}
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
                    opacity: hasAccess('update') ? 1 : 0.5,
                  }}
                  disabled={!hasAccess('update')}
                >
                  <img
                    src={editIcon}
                    style={{ height: '20px', width: '20px' }}
                    alt="edit"
                  />
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete();
                  }}
                  style={{ border: 'none', background: 'none',cursor: 'pointer' }}
                >
                  <img
                    src={deleteIcon}
                    style={{
                      border: 'none',
                      background: 'none',
                      cursor: hasAccess('delete') ? 'pointer' : 'not-allowed',
                      opacity: hasAccess('update') ? 1 : 0.5,
                    }}
                    alt="delete"
                    disabled={!hasAccess('delete')}
                  />
                </button>
              </div>
            )}
          </div>
        </AccordionSummary>

        <AccordionDetails className={styles['accordion-details']}>
          {node.details ? (
            <ApproverDisplay
              details={details}
              approverOptions={approverOptions}
              onApproverChange={handleApproverChange}
            />
          ) : (
            node.children?.map((child) => (
              <RecursiveAccordion
                key={child.id}
                node={child}
                approverOptions={approverOptions}
                updateDetails={updateDetails}
                level={level + 1}
                handleEdit={handleEdit}
              />
            ))
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

RecursiveAccordion.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string.isRequired,
    parameter: PropTypes.string.isRequired,
    parameterLabel: PropTypes.string.isRequired,
    details: PropTypes.shape({
      firstApprover: PropTypes.string,
      secondApprover: PropTypes.string,
      thirdApprover: PropTypes.string,
    }),
    children: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  approverOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateDetails: PropTypes.func.isRequired,
  level: PropTypes.number,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  hasAccess: PropTypes.func.isRequired, 
};


export default RecursiveAccordion;
